// Afstandsformulier — route-hulpjes zonder React, zodat ze los te testen zijn.
//
// Een eigenaar bereikt het formulier via de pagina van zijn eigen asiel op DierMatch:
// `/afstand/<opvangsleutel>`. De sleutel staat in het PAD en niet in een vraagteken-parameter, omdat
// het een deelbare, blijvende link is die een asiel op zijn eigen site mag zetten — net als de
// opvangpagina waar hij vandaan komt.
//
// Anders dan de nazorglink is de sleutel GEEN geheim: hij wijst een asiel aan, niet een persoon. Wat
// wel geheim is, is de aanvraag-sleutel die het asiel uitgeeft zodra het formulier begint; die blijft
// in het geheugen van de pagina en komt nooit in de adresbalk te staan.

const AFSTAND_PREFIX = "/afstand";

/** Waar of het huidige pad het afstandsformulier is (`/afstand` of `/afstand/<opvangsleutel>`). */
export function isAfstandPath(pathname: string | null | undefined): boolean {
  if (!pathname) {
    return false;
  }
  const path = pathname.replace(/\/+$/, "");
  return path === AFSTAND_PREFIX || path.startsWith(`${AFSTAND_PREFIX}/`);
}

/**
 * De opvangsleutel uit een `/afstand/<sleutel>`-pad, of `""` als er geen in staat.
 *
 * <p>Neemt het pad als argument en niet `location`, zodat hij zonder browser te testen is.
 */
export function readOpvangSleutel(pathname: string | null | undefined): string {
  if (!pathname) {
    return "";
  }
  const match = pathname.replace(/\/+$/, "").match(/^\/afstand\/(.+)$/);
  if (!match || match[1] === "index.html") {
    return "";
  }
  const sleutel = match[1].split("/")[0];
  try {
    return decodeURIComponent(sleutel).trim();
  } catch {
    return sleutel.trim();
  }
}
